import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["mainImage", "fullscreenOverlay", "fullscreenImage"];
  static values = {
    modalId: String,
  };

  switchImage(event) {
    if (!this.originalImageUrl) {
      this.originalImageUrl = this.mainImageTarget.src;
      this.originalLargeUrl = this.mainImageTarget.dataset.largeUrl;
    }

    const newImageUrl = event.target.dataset.modalImageSwitcherImageUrl;
    const newLargeUrl = event.target.dataset.modalImageSwitcherLargeUrl;

    this.mainImageTarget.src = newImageUrl;
    if (newLargeUrl) {
      this.mainImageTarget.dataset.largeUrl = newLargeUrl;
    }
  }

  revertImageToOriginal({ detail: { id } }) {
    if (this.modalIdValue === id && this.originalImageUrl) {
      this.mainImageTarget.src = this.originalImageUrl;
      if (this.originalLargeUrl) {
        this.mainImageTarget.dataset.largeUrl = this.originalLargeUrl;
      }
      this.originalImageUrl = null;
      this.originalLargeUrl = null;
    }
  }

  openFullscreen(event) {
    event.stopPropagation();
    if (!this.hasFullscreenOverlayTarget || !this.hasMainImageTarget) return;

    const largeUrl = this.mainImageTarget.dataset.largeUrl;
    if (largeUrl) {
      this.fullscreenImageTarget.src = largeUrl;
      this.fullscreenOverlayTarget.classList.remove("hidden");
      this.fullscreenOverlayTarget.classList.add("flex");
      // Deliberately no scroll lock, and do not add one
      // back. Locking `body` was inert: `main` is the
      // scroller on the customer layout
      // (app/views/layouts/users/layout.rb:138-140) and
      // `#window-component` on admin. Moving the lock to the
      // real scroller would still buy nothing, because this
      // overlay renders inside an item <dialog> opened with
      // showModal(), which already blocks scrolling the page
      // behind it. Measured, not reasoned, with real wheel
      // input on the customer menu: main.scrollTop moved
      // 0 to 556 with no modal open, and 0 to 0 with the
      // modal open, overlay open or closed.
    }
  }

  closeFullscreen(event) {
    if (!this.hasFullscreenOverlayTarget) return;

    // Don't close if clicking the image itself
    if (event && event.target === this.fullscreenImageTarget) return;

    this.fullscreenOverlayTarget.classList.add("hidden");
    this.fullscreenOverlayTarget.classList.remove("flex");
  }
}
